export default "__VITE_ASSET__CZBQvsXp__"